import React, { Fragment } from "react";

import Header from "../../components/header/header";

import "./about.scss";

const About = () => (
  <Fragment>
    <Header />
    <section className="page_container">
      <div className="about_section">
        <p className="about_pirentz">
          Pirentz is a mobile application for faster, reliable and affordable
          hiring of construction equipment.
        </p>
        <div className="terms_links">
          <a href="/terms-hiring-party.html" className="each_link">
            Terms & Conditions for Hiring Party
          </a>
          <a href="/terms-machine-owner.html" className="each_link">
            Terms & Conditions for Machine Owner
          </a>
          <a href="/privacy-policy.html" className="each_link">
            Privacy Policy
          </a>
        </div>
        <div className="terms_links">
          <a href="/account-deletion" className="each_link">
            Account Deletion
          </a>
        </div>
      </div>
    </section>
  </Fragment>
);

export default About;
